const { document } = require('global');

exports.onRouteUpdate = location => {
  if (location.hash) {
    setTimeout(() => {
      document.querySelector(`${location.hash}`).scrollIntoView();
    }, 0);
  }
};



// WEBPACK FOOTER //
// ./gatsby-browser.js